angular.module('impactx.invoice').controller('ContractCompanySelectionDialogCtrl', [
    '$scope',
    '$mdDialog',
    'themeFactory',
    'dataGen',
    'TranslationService',
    'headerLabel',
    'cscId',
    ContractCompanySelectionDialogCtrl]);

function ContractCompanySelectionDialogCtrl($scope, $mdDialog, themeFactory, dataGen, TranslationService, headerLabel, cscId) {
    var ctrl = this;
    $scope.theme = themeFactory.getTheme();
    $scope.hasBANFContractWithSupplierCatalog = false;

    $scope.wizardIndex = 0;
    $scope.data = {};
    $scope.data.type = {};
    $scope.data.isModelContract = false;

    $scope.forwardLabel = TranslationService.get("forward");
    $scope.abortLabel = TranslationService.get("abort");
    $scope.headerLabel = headerLabel;
    $scope.backLabel = TranslationService.get("back");

    $scope.data.buyerCompany = {};
    $scope.data.buyerCompany.selected = null;

    $scope.data.supplierCompany = {};
    $scope.data.supplierCompany.selected = null;

    $scope.data.contactBuyer = {};
    $scope.data.contactBuyer.selected = null;

    $scope.data.catalog = {};
    $scope.data.catalog.selected = null;

    $scope.data.masterContract = {};
    $scope.data.masterContract.selected = null;

    $scope.buyerComId = 0;
    $scope.supplierComId = 0;

    dataGen.getData({}, {}, "/cscontract/companyselection/type").then(function (data) {
        $scope.data.type = data.data;
        dataGen.getData({}, {cscId:cscId}, "/cscontract/companyselection/maindata", null, true).then(function (data) {
            $scope.trns = data.trns;
            $scope.hasBANFContractWithSupplierCatalog = data.data.hasBANFContractWithSupplierCatalog;
            if(cscId && data.data.csc)
            {
                $scope.nameOG = data.data.csc.contractName;
                $scope.data.type.selected = data.data.csc.cscType;
                $scope.data.isModelContract = data.data.csc.isMDM;
                $scope.data.masterContract.selected = data.data.csc.masterContract;
                $scope.data.buyerCompany.selected = data.data.csc.buyerCompany;
                $scope.data.supplierCompany.selected = data.data.csc.supplierCompany;
                $scope.data.contactBuyer.selected = data.data.csc.buyerContact;
                $scope.data.catalog.selected = data.data.csc.catalog;

                $scope.cscOG = data.data.csc;
                $scope.isSlaveOfGivenContract = data.data.csc.masterContract && true;
                $scope.wizardIndex = $scope.isSlaveOfGivenContract? 3 : 2;

                $scope.buyerComId = data.data.csc.buyerCompany.id;
                $scope.supplierComId = data.data.csc.supplierCompany.id;
                $scope.data.copyConfiguration = data.data.csc.copyConfiguration;
            }
        });
    });

    this.copyFunction = function () {
        return cscId && true;
    }

    this.isDisabled = function (entry) {
        return (entry.onlyForSameBuyer && $scope.data.buyerCompany.selected.id !== $scope.buyerComId) ||
            (entry.onlyForSameSupplier && $scope.data.supplierCompany.selected.id !== $scope.supplierComId);
    }

    this.isAtMinScreen = function() {
        if(ctrl.copyFunction())
        {
            return $scope.wizardIndex === ($scope.isSlaveOfGivenContract? 3 : 2);
        }
        return $scope.wizardIndex === 0;
    }

    this.forward = function () {
        if ($scope.wizardIndex === 0) {
            //slave
            if ($scope.data.type.selected.id === 3) {
                $scope.wizardIndex++;
            }
            else {
                $scope.wizardIndex = 2;
            }
        }
        else if ($scope.wizardIndex === 2) {
            if ($scope.data.type.selected.id === 3) {
                //slave
                ctrl.checkUniqueAndCallFollowIndex(5);
            }
            else {
                $scope.wizardIndex++;
            }
            if ($scope.data.buyerCompany.selected.id !== $scope.buyerComId)
            {
                $scope.data.copyConfiguration.copyNus.value = false;

                if(ctrl.isDisabled($scope.data.copyConfiguration.copyNus))
                {
                    $scope.data.copyConfiguration.copyNus.label = $scope.data.copyConfiguration.copyNus.label + " (" + $scope.trns.onlySameBuyerNUS + ")";

                }
                if(ctrl.isDisabled($scope.data.copyConfiguration.copyInvoiceAddressBuyer))
                {
                    $scope.data.copyConfiguration.copyInvoiceAddressBuyer.label = $scope.data.copyConfiguration.copyInvoiceAddressBuyer.label + " (" + $scope.trns.onlySameBuyer + ")";
                }
            }
        }
        else if ($scope.wizardIndex === 3) {
            if ($scope.data.type.selected.id === 6 ||
                ($scope.data.type.selected.id === 7 && !$scope.hasBANFContractWithSupplierCatalog)) {
                //leasing or slave or banf + flag
                ctrl.checkUniqueAndCallFollowIndex(5);
            }
            else {
                $scope.wizardIndex++;
            }
        }
        else if ($scope.wizardIndex === 4)
        {
            ctrl.checkUniqueAndCallFollowIndex($scope.wizardIndex + 1);
        }
        else
        {
            $scope.wizardIndex++;
        }
        if (ctrl.checkFinish()) {
            ctrl.finish();
        }
    };

    this.checkFinish = function() {
        return ctrl.copyFunction()? $scope.wizardIndex === 7: $scope.wizardIndex === 6;
    }

    this.checkUniqueAndCallFollowIndex = function(followIndex)
    {
        var data = {
            type: $scope.data.type.selected && $scope.data.type.selected.id ? $scope.data.type.selected.id : 0,
            buyerComId: $scope.data.buyerCompany.selected && $scope.data.buyerCompany.selected.id ? $scope.data.buyerCompany.selected.id : 0,
            supplierComId: $scope.data.supplierCompany.selected && $scope.data.supplierCompany.selected.id ? $scope.data.supplierCompany.selected.id : 0,
            catalogId: $scope.data.catalog.selected && $scope.data.catalog.selected.id ? $scope.data.catalog.selected.id : 0,
            masterContractId: $scope.data.masterContract.selected && $scope.data.masterContract.selected.id ? $scope.data.masterContract.selected.id : 0,
            contractId: 0
        };
        dataGen.getData({}, data,
            "/cscontract/checknotexisting").then(function (data) {
            if (data.data.existing)
            {
                $scope.errorMessage = $scope.trns.alreadyExistingError;
            }
            else
            {
                $scope.errorMessage = null;
                $scope.wizardIndex = followIndex;
            }

        });
    };

    this.back = function () {
        $scope.errorMessage = null;
        switch($scope.wizardIndex)
        {
            case 1:
                $scope.data.masterContract.selected = null;
                break;
            case 2:
                $scope.data.buyerCompany.selected = null;
                break;
            case 3:
                $scope.data.supplierCompany.selected = null;
                break;
            case 4:
                $scope.data.catalog.selected = null;
                break;
            case 5:
                $scope.data.contactBuyer.selected = null;
        }
        if ($scope.wizardIndex === 2) {
            //slave
            if ($scope.data.type.selected.id === 3) {
                $scope.wizardIndex--;
            }
            else {
                $scope.wizardIndex = 0;
            }
        }
        else if ($scope.wizardIndex === 5) {
            if ($scope.data.type.selected.id === 3) {
                $scope.wizardIndex = 2;
            }
            else {
                $scope.wizardIndex--;
            }
        }
        // Niemals erreicht?
        else if ($scope.wizardIndex === 5) {
            //leasing or slave or banf + flag
            if ($scope.data.type.selected.id === 6 ||
                ($scope.data.type.selected.id === 7 && !$scope.hasBANFContractWithSupplierCatalog)) {
                $scope.wizardIndex = 3;
            }
            else {
                $scope.wizardIndex--;
            }
        }
        else if ($scope.wizardIndex > 0) {
            $scope.wizardIndex--;
        }
    };

    this.cancel = function () {
        $mdDialog.cancel();
    };

    this.getBuyerCompanyEntries = function (searchText) {
        return dataGen.getData({}, {isResellerSlave: $scope.data.type.selected.id === 3, searchText: searchText},
            "/cscontract/companyselection/buyercompany", null, true).then(function (data) {
            return data.data;
        });
    };

    this.getSupplierCompanyEntries = function (searchText) {
        return dataGen.getData({}, {contractType: $scope.data.type.selected.id, buyerCompanyId: $scope.data.buyerCompany.selected.id,
            searchText: searchText}, "/cscontract/companyselection/suppliercompany", null, true).then(function (data) {
            return data.data;
        });
    };

    this.getCatalogEntries = function (searchText) {
        return dataGen.getData({}, {supplierCompanyId: $scope.data.supplierCompany.selected.id, searchText: searchText},
            "/cscontract/companyselection/catalog", null, true).then(function (data) {
            return data.data.entries;
        });
    };

    this.getContactBuyerEntries = function (searchText) {
        return dataGen.getData({}, {buyerCompanyId: $scope.data.buyerCompany.selected.id, searchText: searchText},
            "/cscontract/companyselection/buyercontact", null, true).then(function (data) {
            return data.data.entries;
        });
    };

    this.getMasterContractEntries = function (searchText) {
        return dataGen.getData({}, {searchText: searchText},
            "/cscontract/companyselection/mastercontract", null, true).then(function (data) {
            return data.data.entries;
        });
    };
    this.finish = function () {
        $mdDialog.hide({
            type: $scope.data.type.selected && $scope.data.type.selected.id ? $scope.data.type.selected.id : 0,
            buyerComId: $scope.data.buyerCompany.selected && $scope.data.buyerCompany.selected.id ? $scope.data.buyerCompany.selected.id : 0,
            supplierComId: $scope.data.supplierCompany.selected && $scope.data.supplierCompany.selected.id ? $scope.data.supplierCompany.selected.id : 0,
            contactBuyerId: $scope.data.contactBuyer.selected && $scope.data.contactBuyer.selected.id ? $scope.data.contactBuyer.selected.id : 0,
            catalogId: $scope.data.catalog.selected && $scope.data.catalog.selected.id ? $scope.data.catalog.selected.id : 0,
            masterContractId: $scope.data.masterContract.selected && $scope.data.masterContract.selected.id ? $scope.data.masterContract.selected.id : 0,
            isModelContract: $scope.data.isModelContract,
            copyConfiguration: $scope.data.copyConfiguration
        });
    }
}